import { Component, computed, HostBinding, output } from '@angular/core';
import { ClaimsFormService } from '../claims-form/services/claims-form.service';

@Component({
  selector: 'app-booking-progress-bar',
  imports: [],
  templateUrl: './booking-progress-bar.component.html',
  styleUrl: './booking-progress-bar.component.scss',
})
export class BookingProgressBarComponent {
  showBookingStep = output<void>();

  protected viewModel = computed(() => {
    const jumps = this.claimFormService.state.jumps;
    const numberOfStepsInForm = jumps.length;
    // This is to include the current step we are on
    const percentagePerStage = 100 / numberOfStepsInForm;

    const currentPositionInForm =
      jumps.findIndex((i) => i.direction === 'FORWARDS') >= 0
        ? jumps.findIndex((i) => i.direction === 'FORWARDS')
        : jumps.length - 1;

    let percentage = currentPositionInForm * percentagePerStage;

    // Work of the extra percentage for progress through the stage

    let stagePercentage = 0;

    const numberOfStepsInStage = this.claimFormService.state.currentClaimSteps?.steps?.length ?? 1;
    const stepPercentage = percentagePerStage / numberOfStepsInStage;
    stagePercentage = this.claimFormService.state.currentSubStep * stepPercentage;

    return {
      showPercentageBar: this.claimFormService.state.currentClaim,
      percentage: parseInt(`${percentage + stagePercentage}`),
    };
  });

  get vm() {
    return this.viewModel();
  }

  @HostBinding('class')
  get classList() {
    if (!this.vm.showPercentageBar) return 'hide';
    return '';
  }

  constructor(private readonly claimFormService: ClaimsFormService) {}
}
